/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePtTestLandingPageFragment, PtTestLandingPageFragment, FullPtTestLandingPageFragment} from '@amblique/contentful/app/contentful/fragments/pt-test-landing-page';

/**
 * Get a single PtTestLandingPage by ID (base - scalars only)
 */
export const getBasePtTestLandingPageById = gql`
  ${BasePtTestLandingPageFragment}

  query GetBasePtTestLandingPageById($id: String!, $locale: String!, $preview: Boolean) {
    ptTestLandingPage(id: $id, locale: $locale, preview: $preview) {
      ...BasePtTestLandingPageFragment
    }
  }
`;

/**
 * Get a single PtTestLandingPage by ID (standard - 1 level deep)
 */
export const getPtTestLandingPageById = gql`
  ${PtTestLandingPageFragment}

  query GetPtTestLandingPageById($id: String!, $locale: String!, $preview: Boolean) {
    ptTestLandingPage(id: $id, locale: $locale, preview: $preview) {
      ...PtTestLandingPageFragment
    }
  }
`;

/**
 * Get a single PtTestLandingPage by ID (full - 2 levels deep)
 */
export const getFullPtTestLandingPageById = gql`
  ${FullPtTestLandingPageFragment}

  query GetFullPtTestLandingPageById($id: String!, $locale: String!, $preview: Boolean) {
    ptTestLandingPage(id: $id, locale: $locale, preview: $preview) {
      ...FullPtTestLandingPageFragment
    }
  }
`;

/**
 * Get all PtTestLandingPage entries with pagination (base - scalars only)
 */
export const getBasePtTestLandingPages = gql`
  ${BasePtTestLandingPageFragment}

  query GetBasePtTestLandingPages(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PtTestLandingPageOrder]
    $where: PtTestLandingPageFilter
    $preview: Boolean
  ) {
    ptTestLandingPageCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BasePtTestLandingPageFragment
      }
    }
  }
`;

/**
 * Get all PtTestLandingPage entries with pagination (standard - 1 level deep)
 */
export const getPtTestLandingPages = gql`
  ${PtTestLandingPageFragment}

  query GetPtTestLandingPages(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PtTestLandingPageOrder]
    $where: PtTestLandingPageFilter
    $preview: Boolean
  ) {
    ptTestLandingPageCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...PtTestLandingPageFragment
      }
    }
  }
`;

/**
 * Get all PtTestLandingPage entries with pagination (full - 2 levels deep)
 */
export const getFullPtTestLandingPages = gql`
  ${FullPtTestLandingPageFragment}

  query GetFullPtTestLandingPages(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PtTestLandingPageOrder]
    $where: PtTestLandingPageFilter
    $preview: Boolean
  ) {
    ptTestLandingPageCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullPtTestLandingPageFragment
      }
    }
  }
`;
